import { useSelector } from "react-redux";
import WebsiteTunnelSwitcher from "./WebsiteTunnelSwitcher";
import { getAvailableStopoverCities } from "app/pages/SmartDP/smartDPSelectors";

const WebsiteTunnelSwitcherContainer = props => {
	const stopoverCities = useSelector(getAvailableStopoverCities);
	return <WebsiteTunnelSwitcher stopoverCities={stopoverCities} {...props} />;
};

export default WebsiteTunnelSwitcherContainer;
